export const getCombinedPageFunctions = ({
  pageFunctions,
  pageFunctionMethods,
}: {
  pageFunctions: Record<string, unknown>;
  pageFunctionMethods: Record<string, unknown>;
}) => {
  const combinedPageFunctions: Record<string, unknown> = {};
  const keys = Object.keys(pageFunctions);
  const keysLength = keys.length;

  for (let i = 0; i < keysLength; i++) {
    const key = keys[i];
    combinedPageFunctions[key] = {
      ...(pageFunctions[key] as Record<string, unknown>),
      ...(pageFunctionMethods[key] as Record<string, unknown>),
    };
  }

  // add methods for functions that might not be in pageFunctions state yet
  const methodKeys = Object.keys(pageFunctionMethods);
  const methodKeysLength = methodKeys.length;

  for (let i = 0; i < methodKeysLength; i++) {
    const key = methodKeys[i];
    if (!combinedPageFunctions[key]) {
      combinedPageFunctions[key] = pageFunctionMethods[key];
    }
  }

  return combinedPageFunctions;
};
